import { Tooltip } from "@impero-com/ui";

import { useIsClamped } from "utils/hooks/useIsClamped";

import * as theme from "./ClampedText.css";

interface ClampedTextProps {
    text: string;
}

/**
 * Truncates text to two lines with an ellipsis. The full text is available in a
 * tooltip, but only while the text is actually truncated.
 */
export function ClampedText({ text }: ClampedTextProps) {
    const { ref, isClamped } = useIsClamped();

    return (
        <Tooltip title={text} disabled={!isClamped} noWrapper>
            <span ref={ref} className={theme.clamped}>
                {text}
            </span>
        </Tooltip>
    );
}
